import ElTreeV2 from "./src/tree.vue";

export default ElTreeV2;
